/**
 * BreadCrumbService
 */

// Core
import { Injectable } from '@angular/core';


//Vanilla JS
import _forEach from 'lodash-es/forEach';
import _set from 'lodash-es/set';
import _get from 'lodash-es/get';
import _find from 'lodash-es/find';
import _keys from 'lodash-es/keys';

import { IBreadcrumbItem } from './IBreadcrumbItem';
import { IWenji, SearchResultOption } from "../../interfaces/IWenji";

declare const wenji: IWenji;

export interface IPnrPageParameters {
    host: string;
    booking: string;
}

@Injectable()
export class BreadcrumbService {
    // Please don't rely on this property
    // For the moment its reference does not change, but that's not a good practice
    // and may change
    public items: IBreadcrumbItem[] = [];
    private context: string;
    private showQuotes: boolean;
    private pnrPageParameters: IPnrPageParameters;

    public setContext(context: string): void {
        this.context = context;
    }

    public getContext(): string {
        return this.context;
    }

    public getItems(): IBreadcrumbItem[] {
        return this.items;
    }

    /**
     *
     * activate selected item, desactivate the others
     *
     */
    public setActive(_index: number) {
        _forEach(this.items, (item: any) => {
            // item.isActive = false
            _set(item, 'isActive', false);
        });

        _set(this.items[_index], 'isActive', true);
    }

    /**
     * specify if an item is clickable or not
     */
    public setClickable(_index: number, _bool: boolean) {
        _set(this.items[_index], 'isClickable', _bool);
    }

    /**
     * test if an item is active
     */
    public isActive(_index: number): boolean {
        return this.items[_index].isActive;
    }

    /**
     * Add Page on breadCrumb
     */
    public addPage(_pageObject: any): void {
        this.items.push(_pageObject);
    }

    public isTileInActive(_tileName): boolean {
        //get currently active item;

        const activeItem = _find(this.items, (item: any) => item.isActive === true);

        return _get(activeItem && activeItem.tile, _tileName);
    }

    public provisionalItems: any[];

    public nbPages(): number {
        return _keys(this.provisionalItems).length + 1;
    }

    public setItems(items: IBreadcrumbItem[]): void {
        this.items.length = 0;
        this.items.push(...items);
    }

    public setShowQuotes(state: boolean): void {
        this.showQuotes = state;
    }

    public getShowQuotes(): boolean {
        return this.showQuotes;
    }

    public setPnrPageParameters(host: string, booking: string): void {
        this.pnrPageParameters = {host, booking};
    }

    public getPnrPageParameters(): IPnrPageParameters {
        return this.pnrPageParameters;
    }
}
